import React from 'react';
import styles from './components.module.css';

export interface FormNavigationButtonsProps {
  currentPage: number;
  totalPages: number;
  isSubmitting: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  prevText?: string;
  nextText?: string;
  submitText?: string;
  canGoNext?: boolean;
}

export const FormNavigationButtons: React.FC<FormNavigationButtonsProps> = ({
  currentPage,
  totalPages,
  isSubmitting,
  onPrevious,
  onNext,
  onSubmit,
  prevText = 'Anterior',
  nextText = 'Próximo',
  submitText = 'Enviar',
  canGoNext = true,
}) => {
  const isFirstPage = currentPage === 0;
  const isLastPage = currentPage === totalPages - 1;

  return (
    <div className={styles.navigationButtons}>
      <button
        type="button"
        className={`${styles.navigationButton} ${styles.prevButton}`}
        onClick={onPrevious}
        disabled={isFirstPage || isSubmitting}
        style={{ visibility: isFirstPage ? 'hidden' : 'visible' }}
      >
        {prevText}
      </button>

      {isLastPage ? (
        <button
          type="button"
          className={`${styles.navigationButton} ${styles.submitButton}`}
          onClick={onSubmit}
          disabled={isSubmitting || !canGoNext}
        >
          {isSubmitting ? 'Enviando...' : submitText}
        </button>
      ) : (
        <button
          type="button"
          className={`${styles.navigationButton} ${styles.nextButton}`}
          onClick={onNext}
          disabled={isSubmitting || !canGoNext}
        >
          {nextText}
        </button>
      )}
    </div>
  );
};

export default FormNavigationButtons;
